import { BoxProps, Flex } from '@chakra-ui/react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
interface ErrorBoxProps extends BoxProps {
    error: string;
}
function ErrorBox({ error, ...props }: ErrorBoxProps) {
    const currentColors = useCurrentColors();
    if (error && typeof error === 'object' && error['error']) {
        error = error['error'];
    }
    return (
        <Flex
            position="fixed"
            justify="center"
            align="center"
            direction="column"
            width="100%"
            height="100%"
            p="16px"
            fontSize="14px"
            backgroundColor={currentColors.componentBg}
            color={currentColors.contentText}
            {...props}>
            {error}
        </Flex>
    );
}

export default ErrorBox;
